import React, { useState, useEffect, useRef, useCallback } from "react";
import { publish } from "pubsub-js";
import { NavLink } from "react-router-dom";
import { withRouter } from "react-router";
import eventType from "../../../events/eventType";
import { cx, css } from "emotion";
import {
	scrollMobile,
	painelContent,
	mobilePanelFooter,
	mobilePanel,
	mobilePanelHeader
} from "./style";
import {
	ROUTE_PREFIX_EDIT_OFFER_MOBILE,
	ROUTE_HOME,
	prefixFidelityAndBank,
	prefixOfferMiles,
	prefixCreditCard,
	prefixFinished,
	prefixValidateOffer,
	prefixFinishedError
} from "../../../shared/constants";
import StepEditOfferMiles from "./steps/StepEditOfferMiles";
import StepEditFinished from "./steps/StepEditFinished";
import Button from "../../../../shared/button/button";
import { useNewOffer, clearContext } from "../../../context/new-offer";
import ArrowLeft from "../../../../shared/atoms/ArrowLeft";
import {
	PanelFooter,
	PanelContent,
	PanelHeader,
	Panel
} from "../../../../shared/create-offer/Panel";
import StepEditFidelityAndBank from "./steps/StepEditFidelityAndBank";
import StepEditCreditCard from "./steps/StepEditCreditCard";
import {
	EditarOfertaModal,
	OfertaEmVendaModal,
	VinduloPendenteModal,
	VendaRapidaNaoElegivel,
	MediaVendasModal,
	AvisoProblemaModal,
	AvisoProblemaModalPagamentoAntecipado,
	PagamentoAntecipadoNaoElegivel
} from "../../../services/modals";
import StepExpectedGainEdit from "../shared/StepExpectedGainEdit";
import Loading from "../../../../shared/create-offer/Loading/Loading";
import { handleFidelityNameToPath, uuid } from "../../../shared/utils";
import EditOfferResult from "./steps/StepEditFinished/EditOfferResult";
import ModalDynamicRange from "../../../../shared/create-offer/ModalDynamicRange/ModalDynamicRange";
import ModalDynamicBonus from "../../../../shared/create-offer/ModalDynamicBonus/ModalDynamicBonus";
import { patternOnlyNumbers } from "../../../../shared/create-offer/utils/masks";
import { GOL_ACRONYM, GOL_FIDELITY_PROGRAM, Type2FA } from "../../../../../js/shared/constants";
import ModalErrorTwoFactorAuthentication from "../../../../shared/create-offer/ModalErrorTwoFactorAuthentication/ModalErrorTwoFactorAuthentication";
import ModalProcessingTwoFactorAuthentication from "../../../../shared/create-offer/ModalProcessingTwoFactorAuthentication/ModalProcessingTwoFactorAuthentication";
import Await2FAModal from "../../../../shared/create-offer/Await2FAModal/Await2FAModal";

// Debounce function
let timerId;

const debounced = (fn, delay = 250) => {
	if (timerId) clearTimeout(timerId);
	timerId = setTimeout(fn, delay);
};

const EditOfferMobile = ({ history, match, typePhoneLatam }) => {
	const editOfferRef = useRef();
	const {
		editOffer,
		postData,
		selectOfferToEdit,
		pricesData,
		userData,
		rankingData,
		smilesRange,
		newOfferTempData,
		setNewOfferTempData,
		quickSaleProblem,
		setQuickSaleProblem,
		currentProgram,
		creditCardData,
		offerData,
		setOfferData,
		fetchPricesData,
		offerSentStatus,
		forceStep,
		setForceStep,
		participantData,
		bonusData: { data: bonusData },
		acceptanceTerms,
		forwardPaymentProblem,
		setForwardPaymentProblem,
		loyaltyData,
		email2FAStatusValidation,
		showModalErrorTwoFactorAuthentication,
		setShowModalErrorTwoFactorAuthentication,
		twoFactorData,
		send2FACode,
		hasClickedRequest2FACode,
		setHasTriedToProceedWithout2FA,
		uuidCybersource,
		setUuidCybersource
	} = useNewOffer();

	const [index, setIndex] = useState(0);
	const [oldQuantMiles, setOldQuantMiles] = useState(0);
	const [modals, setModals] = useState({
		ofertaEmVenda: false,
		editarOferta: false,
		avisoProblemaModal: false,
		avisoProblemaModalPagamentoAntecipado: false,
		twoFactor: false
	});
	const [modalMedia, setModalMedia] = useState({
		mediaVendas: false,
		averageMilesSuggestion: 0,
		sale: {}
	});
	const checkFormData = useRef(newOfferTempData.form);
	const [openFidelityAndBank, setOpenFidelityAndBank] = useState(false);
	const [showCreditCard] = useState(
		!creditCardData.hasCreditCard &&
			currentProgram &&
			currentProgram.international === "1" &&
			(currentProgram.id == 25 ||
				currentProgram.id == 11 ||
				currentProgram.id == 10 ||
				currentProgram.id == 14)
	);

	const [openDynamicRange, setOpenDynamicRange] = useState(false);
	const [openDynamicBonus, setOpenDynamicBonus] = useState(false);
	const [averageMilesTemp, setAverageMilesTemp] = useState(undefined);

	const { averageMiles, quant: quantOfferMiles } = offerData.data;

	useEffect(() => {
		const { quant } = offerData?.data;

		if (!oldQuantMiles) {
			setOldQuantMiles(quant);
		}
	}, [offerData, oldQuantMiles]);

	const changeAverageSlider = async (value = averageMilesTemp || averageMiles) => {
		setAverageMilesTemp(undefined);
		await setOfferData({
			data: { ...offerData.data, averageMiles: value }
		});
		debounced(() => fetchPricesData(quantOfferMiles, currentProgram, value), 600);
	};

	const saveAverageSliderTemp = async value => {
		setAverageMilesTemp(value);
	};

	const isQuickSale = editOffer && editOffer.quickSale;

	const isForwardPayment = editOffer && editOffer.forwardPayment;

	const bonusValid =
		!isQuickSale && !isForwardPayment && bonusData.enabled && quantOfferMiles >= 15000;

	const checkData = (box, value) => {
		let newValue = value;
		if (box === "completedBoxDataFidelityProgramDetails") {
			newValue = typePhoneLatam === 0 ? value : true;
		}
		checkFormData.current = {
			...checkFormData.current,
			[box]: newValue
		};

		let values = {
			...newOfferTempData,
			form: {
				...checkFormData.current
			}
		};

		setNewOfferTempData(values);
	};

	const setOpenBankFidedity = () => {
		setOpenFidelityAndBank(true);
		setIndex(1);
	};

	const setDynamicRange = () => {
		setOpenDynamicRange(!openDynamicRange);
	};

	const buildPath = prefix => {
		return `${prefix}/${handleFidelityNameToPath(currentProgram)}`;
	};

	const steps = [
		{
			path: buildPath(prefixValidateOffer),
			component: () => <StepEditFinished history={history} />
		}
	];

	if (openFidelityAndBank || isQuickSale || isForwardPayment) {
		steps.splice(0, 0, {
			path: buildPath(prefixFidelityAndBank),
			component: () => (
				<StepEditFidelityAndBank
					typePhoneLatam={typePhoneLatam}
					checkData={checkData}
					currentProgram={currentProgram}
				/>
			)
		});
	}
	if (!isQuickSale && !isForwardPayment) {
		steps.splice(0, 0, {
			path: buildPath(prefixOfferMiles),
			component: () =>
				forceStep !== undefined ||
				userData.isFetching ||
				modals.vendaRapidaNaoElegivel ||
				modals.pagamentoAntecipadoNaoElegivel ? (
					<Loading width={120} height={120} />
				) : (
					<StepEditOfferMiles
						setOpenBankFidedity={setOpenBankFidedity}
						checkData={checkData}
						forceStep={forceStep}
						ref={editOfferRef}
						passData={data => passDataToContext(data)}
						setModalDynamicRange={() => setDynamicRange()}
						openModalDynamicBonus={() => setOpenDynamicBonus(true)}
						bonusValid={bonusValid}
					/>
				)
		});
	}
	if (showCreditCard) {
		steps.splice(steps.length - 1, 0, {
			path: buildPath(prefixCreditCard),
			component: () => <StepEditCreditCard checkData={checkData} />
		});
	}

	const matchPath = `${match.params.path}`;
	const matchIndex = steps.findIndex(step => step.path === matchPath);

	const currentStep = steps[index] || {
		path: buildPath(prefixFinished),
		component: () => <EditOfferResult typePhoneLatam={typePhoneLatam} />
	};

	useEffect(() => {
		return () => {
			selectOfferToEdit({}); // Limpa edição
		};
	}, []);

	useEffect(() => {
		if (matchIndex > index) {
			history.push(`${ROUTE_PREFIX_EDIT_OFFER_MOBILE}/${currentStep.path}`);
		} else if (steps[matchIndex]) {
			setIndex(matchIndex);
		} else if (
			match.params.path &&
			(match.params.path.includes(prefixFinished) ||
				match.params.path.includes(prefixFinishedError))
		) {
			setIndex(steps.length);
		}
	}, [match, history, matchIndex]);

	useEffect(() => {
		window.scrollTo(0, 0);
		if (!editOffer.id) {
			history.push(ROUTE_HOME);
		} else if (currentStep.path && !currentStep.path.includes(prefixFinished)) {
			history.push(`${ROUTE_PREFIX_EDIT_OFFER_MOBILE}/${currentStep.path}`);
		}
	}, [index]);

	useEffect(() => {
		setModals({
			...modals,
			ofertaEmVenda: editOffer.status === 3,
			ofertaNaoAprovada: editOffer.status !== 3 && editOffer.editable === false,
			vendaRapidaNaoElegivel: quickSaleProblem,
			pagamentoAntecipadoNaoElegivel: forwardPaymentProblem,
			avisoProblemaModalPagamentoAntecipado:
				editOffer.editable == false && editOffer.type == 4 && editOffer.status !== 4,
			vinculoPendente: participantData.isDone && participantData.hasRelationshipPendent,
			avisoProblemaModal: editOffer.editable == false
		});
	}, [editOffer, quickSaleProblem, participantData, forwardPaymentProblem]);

	useEffect(() => {
		if (forceStep === 3) {
			setForceStep(undefined);
		}
	}, [forceStep]);

	const prev = () => {
		if (index > 0 && localStorage.getItem("openBankFidelity") != 1) {
			setIndex(index - 1);
		} else {
			localStorage.setItem("openBankFidelity", "0");
			history.push(ROUTE_HOME);
		}
	};

	const closeTwoFactorModal = () => {
		setModals({ ...modals, twoFactor: false });
		next(undefined, true);
	};

	const handleTwoFactorModalConfirm = () => {
		send2FACode();
		closeTwoFactorModal();
	};

	const handleTwoFactorModalCancel = () => {
		closeTwoFactorModal();
	};

	const next = useCallback(
		(ev, ignoreModal = false) => {
			const { fidelityName, international } = currentProgram;
			const { quant: actualQuantMiles, price: priceMiles, avergeMiles } = offerData?.data;
			const { path: step } = currentStep;

			let nextIndex = index + 1;

			const isBankFidelityCompleted =
				newOfferTempData.form.completedBoxDataFidelityProgramDetails &&
				newOfferTempData.form.completedBoxDataBankDetails;

			if (!openFidelityAndBank && !isBankFidelityCompleted) {
				localStorage.setItem("openBankFidelity", "1");
				setOpenBankFidedity();
				setOpenFidelityAndBank(true);
				return;
			}

			if (openFidelityAndBank) {
				localStorage.setItem("openBankFidelity", "0");
				setIndex(0);
				setOpenFidelityAndBank(false);
			} else if (nextIndex < steps.length) {
				if (
					!ignoreModal &&
					((currentStep.path.includes(prefixOfferMiles) && international === "0") ||
						isQuickSale ||
						isForwardPayment)
				) {
					if (twoFactorData.is2FAEnabled && !hasClickedRequest2FACode) {
						setHasTriedToProceedWithout2FA(true);
						return;
					}
					// Aparecer sempre no fluxo de edição após tela de ofertar milhas | nacional apenas
					setModals({
						...modals,
						editarOferta: true
					});
					return;
				}

				if (steps[nextIndex].path.includes(prefixValidateOffer)) {
					if (
						currentProgram.id === GOL_FIDELITY_PROGRAM &&
						loyaltyData.data.twoFactorAuthenticationStrategy === Type2FA.EMAIL_REDIRECT &&
						!email2FAStatusValidation.isValidated
					) {
						nextIndex = nextIndex - 1;
					}
					postData();
					setIndex(nextIndex);
				}
				setIndex(nextIndex);
			}

			publish(eventType.OFFER_EDIT, {
				fidelityName,
				oldQuantMiles,
				actualQuantMiles: quantOfferMiles,
				priceMiles,
				step: `edicao-${step.split("/")[0]}`,
				averageMiles,
				paymentDeadline,
				twoFactorAuthenticationStrategy
			});
		},
		[
			offerData,
			pricesData,
			currentProgram,
			editOffer,
			currentStep,
			steps,
			isQuickSale,
			isForwardPayment,
			prefixOfferMiles,
			loyaltyData,
			quantOfferMiles,
			averageMiles
		]
	);

	const checkNextDisabled = () => {
		const hasInvalidOfferData = offerData?.data?.invalid;
		const isFetchingData = pricesData.isFetching || userData.isFetching || rankingData.isFetching;

		if (
			currentProgram.acronym === GOL_ACRONYM &&
			currentStep.path.includes(prefixFidelityAndBank) &&
			loyaltyData?.data?.phone?.length !== 11
		)
			return true;

		if (hasInvalidOfferData || isFetchingData) {
			return true;
		} else if (
			(loyaltyData?.data?.id === 3 && loyaltyData?.data?.password > 2) ||
			(typePhoneLatam !== 0 &&
				newOfferTempData.form.completedBoxDataFidelityProgramDetails &&
				newOfferTempData.form.completedBoxDataBankDetails &&
				(((loyaltyData?.data?.phone?.length === 0 || !loyaltyData?.data?.phone?.length) &&
					typePhoneLatam === 1) ||
					(loyaltyData?.data?.phone?.length === 11 && loyaltyData?.data?.phone[2] === "9")) &&
				acceptanceTerms)
		) {
			return false;
		} else if (
			loyaltyData?.data?.phone &&
			(loyaltyData?.data?.phone[2]?.match(patternOnlyNumbers)?.join("") !== "9" ||
				loyaltyData?.data?.phone?.match(patternOnlyNumbers)?.join("")?.length !== 11)
		) {
			return true;
		} else if (
			(currentStep.path.includes(prefixOfferMiles) &&
				!newOfferTempData.form.completedBoxOfferMiles) ||
			!acceptanceTerms
		) {
			return true;
		} else if (
			currentStep.path.includes(prefixFidelityAndBank) &&
			((typePhoneLatam === 0 && !newOfferTempData.form.completedBoxDataFidelityProgramDetails) ||
				(!newOfferTempData.form.completedBoxDataBankDetails &&
					!participantData.hasManagementActive) ||
				!acceptanceTerms)
		) {
			return true;
		} else if (
			currentStep.path.includes(prefixCreditCard) &&
			!newOfferTempData.form.completedBoxCreditCardDetails
		) {
			return true;
		}
		return false;
	};

	const passDataToContext = data => {
		setModalMedia(data);
	};

	const editarOfertaConfirm = ev => {
		setModals({
			...modals,
			editarOferta: false
		});

		if (twoFactorData.is2FAEnabled) {
			setModals({
				...modals,
				editarOferta: false,
				twoFactor: true
			});
			return;
		}

		next(ev, true);
	};

	const editarOfertaCancel = () => {
		setModals({
			...modals,
			editarOferta: false
		});
	};

	const confirmMediaFn = () => {
		setModalMedia({
			...modalMedia,
			mediaVendas: false
		});
		editOfferRef.current.confirmVendasModal();
	};

	useEffect(() => {
		if (uuidCybersource) return;
		setUuidCybersource(uuid());
	}, [uuidCybersource]);

	useEffect(() => {
		if (email2FAStatusValidation.isValidated) {
			setIndex(prevIndex => prevIndex + 1);
		}
	}, [email2FAStatusValidation]);

	return (
		<Panel>
			<div
				className={css`
					${mobilePanel};
				`}
			>
				<PanelHeader
					className={css`
						${mobilePanelHeader}
					`}
				>
					{(!isQuickSale ||
						(isQuickSale && index > 0) ||
						!isForwardPayment ||
						(isForwardPayment && index > 0)) &&
					!currentStep.path.includes(prefixValidateOffer) &&
					!currentStep.path.includes(prefixFinished) ? (
						<div
							className="go-back"
							onClick={prev}
							data-action={
								currentStep.path.includes(prefixFidelityAndBank) && "fidelity-and-bank-close"
							}
						>
							<ArrowLeft>Voltar</ArrowLeft>
						</div>
					) : (
						<br />
					)}
					<div className="control-steps">
						<strong>Edição</strong>
					</div>
				</PanelHeader>

				<PanelContent
					className={css`
						${painelContent};
					`}
				>
					<div
						className={css`
							${scrollMobile}
						`}
					>
						{currentStep.component()}
					</div>
				</PanelContent>
				{index < steps.length - 1 ? (
					<PanelFooter
						className={css`
							${mobilePanelFooter}
						`}
					>
						{currentStep.path.includes(prefixOfferMiles) && <StepExpectedGainEdit />}
						<Button
							disabled={checkNextDisabled()}
							onClick={next}
							className="btn-primary-md"
							data-action={
								currentStep.path.includes(prefixFidelityAndBank) && "fidelity-and-bank-save"
							}
						>
							{currentStep.path.includes(prefixFidelityAndBank) && !isQuickSale && !isForwardPayment
								? "Salvar"
								: currentStep.path.includes(prefixOfferMiles) && showCreditCard
								? "Próximo"
								: "Concluir"}
						</Button>
					</PanelFooter>
				) : (
					!offerSentStatus.isFetching &&
					offerSentStatus.success && ( // Verificação pra não aparecer botão errado antes de terminar de carregar
						<PanelFooter
							className={cx(
								css`
									${mobilePanelFooter}
								`,
								"finished"
							)}
						>
							<NavLink
								to={`${ROUTE_HOME}`}
								onClick={() => clearContext()}
								className="btn-primary-md"
								data-action="finished-offer-home"
							>
								Ir para minhas ofertas
							</NavLink>
						</PanelFooter>
					)
				)}
			</div>

			<ModalDynamicRange
				height={283}
				averageMiles={averageMiles}
				startAverage={bonusData.minAverage}
				price={bonusData.value}
				countAllowedSales={rankingData.data.countAllowedSales}
				quantMiles={quantOfferMiles}
				endAverage={bonusData.maxAverage}
				changeAverageSlider={changeAverageSlider} // changeAverageSlider
				show={openDynamicRange}
				closeModal={() => setDynamicRange()}
			/>

			{bonusValid && (
				<ModalDynamicBonus
					height={283}
					averageMiles={averageMilesTemp || averageMiles}
					startAverage={bonusData.minAverage}
					price={bonusData.value}
					countAllowedSales={rankingData.data.countAllowedSales}
					quantMiles={quantOfferMiles}
					endAverage={bonusData.maxAverage}
					changeAverageSlider={saveAverageSliderTemp}
					show={openDynamicBonus}
					minCPFs={bonusData.minCPFs}
					validRange={smilesRange}
					onClose={() => setOpenDynamicBonus(false)}
					onConfirm={() => {
						setOpenDynamicBonus(false);
						changeAverageSlider();
					}}
				/>
			)}

			<VendaRapidaNaoElegivel
				show={modals.vendaRapidaNaoElegivel}
				onConfirm={() => {
					setQuickSaleProblem(false);
					editOffer.quickSale = undefined;
					setModals({ ...modals, vendaRapidaNaoElegivel: false });
				}}
			/>
			<PagamentoAntecipadoNaoElegivel
				show={modals.pagamentoAntecipadoNaoElegivel}
				onConfirm={() => {
					setForwardPaymentProblem(false);
					editOffer.forwardPayment = undefined;
					editOffer.paymentDeadline = undefined;
					setModals({ ...modals, pagamentoAntecipadoNaoElegivel: false });
				}}
			/>
			<OfertaEmVendaModal
				show={modals.ofertaEmVenda}
				onConfirm={() => {
					selectOfferToEdit({}); // Limpar oferta
					history.push(ROUTE_HOME);
				}}
			/>
			<EditarOfertaModal
				isQuickSale={isQuickSale}
				isForwardPayment={isForwardPayment}
				show={modals.editarOferta}
				onConfirm={editarOfertaConfirm}
				onCancel={editarOfertaCancel}
			/>
			<VinduloPendenteModal
				show={modals.vinculoPendente}
				onConfirm={() => {
					setModals({ ...modals, vinculoPendente: false });
					history.push(ROUTE_HOME);
				}}
			/>
			<MediaVendasModal
				show={modalMedia.mediaVendas}
				media={modalMedia.averageMilesSuggestion}
				percent={modalMedia.sale.percentage}
				onConfirm={confirmMediaFn}
				onCancel={() => {
					setModalMedia({
						...modalMedia,
						mediaVendas: false
					});
				}}
			/>
			<AvisoProblemaModal
				show={modals.avisoProblemaModal}
				onConfirm={() => {
					setModals({ ...modals, avisoProblemaModal: false });
					history.push(ROUTE_HOME);
				}}
			/>
			<AvisoProblemaModalPagamentoAntecipado
				show={modals.avisoProblemaModalPagamentoAntecipado}
				onConfirm={() => {
					setModals({ ...modals, avisoProblemaModalPagamentoAntecipado: false });
					history.push(ROUTE_HOME);
				}}
			/>
			<ModalErrorTwoFactorAuthentication
				show={showModalErrorTwoFactorAuthentication}
				onConfirm={() => setShowModalErrorTwoFactorAuthentication(false)}
			/>
			<ModalProcessingTwoFactorAuthentication show={email2FAStatusValidation.isFetching} />

			<Await2FAModal
				show={modals.twoFactor}
				onConfirm={handleTwoFactorModalConfirm}
				onCancel={handleTwoFactorModalCancel}
			/>
		</Panel>
	);
};
export default withRouter(EditOfferMobile);
